//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import cookies from 'js-cookie';

const betaCookie = 'crl8.beta';

export const loadBetaVersionIfEligible = (isEligibleForBeta: boolean) => {
  const hasBetaCookie = !!cookies.get(betaCookie);

  if (isEligibleForBeta) {
    if (!hasBetaCookie) {
      cookies.set(betaCookie, 'true', {
        path: '/',
        expires: aYearFromNow(),
        secure: true,
      });
      window.location.reload();
    }
  } else if (hasBetaCookie) {
    const betaCookieKeys = Object.keys(cookies.get()).filter((key) => key.startsWith(betaCookie));
    betaCookieKeys.forEach((key) => cookies.remove(key));
    window.location.reload();
  }
};

const aYearFromNow = () => {
  const d = new Date();
  d.setFullYear(d.getFullYear() + 1);
  return d;
};
